<template>
  <div :style="$cmsStyles('c_3d661c98f5d0')" class="media-container">
    <tools-bar ref="toolsBar"></tools-bar>
    <div class="media-content">
      <div class="service-wrapper">
        <div v-show="$cms('c_3d661c98f5d0', 'f_0001', true)" class="banner-wrapper">
          <h1 class="title">{{ $cms('c_3d661c98f5d0', 'f_0002', "专业主播孵化，内容创作支持") }}</h1>
          <div class="desc">
            {{ $cms('c_3d661c98f5d0', 'f_0003', "记录生活赛道专业机构") }}
          </div>
          <div class="actions">
            <div class="btn btn-white" @click="onJoinClick(1)">{{ $cms('c_3d661c98f5d0', 'f_0004', "主播合作") }}</div>
            <div class="btn" @click="onJoinClick(2)">{{ $cms('c_3d661c98f5d0', 'f_0005', "商家合作") }}</div>
          </div>
        </div>
        <div class="content-wrapper">
          <div style="background-color: #f8f8f8;">
            <div class="content-header">
              <h2 class="title">{{ $cms('c_3d661c98f5d0', 'f_0006', "核心业务") }}</h2>
              <div class="en-title">{{ $cms('c_3d661c98f5d0', 'f_0007', "Core Business of Media") }}</div>
              <div class="content-desc">{{ $cms('c_3d661c98f5d0', 'f_0008', "提供专业的直播电商全链路解决方案，独创\"全生命周期成长体系\"，实现从头部到中尾部主播的梯度培育") }}</div>
            </div>
            <div class="content-body-1">
              <div class="item" v-for="item in coreBusinessList" :key="item.title">
                <img class="icon" :src="item.icon" loading="lazy" alt="">
                <div class="item-title">{{ item.title }}</div>
                <ul>
                  <li v-for="listItem in item.list" :key="listItem">{{ listItem }}</li>
                </ul>
              </div>
            </div>
          </div>

          <div>
            <div class="content-header">
              <h2 class="title">{{ $cms('c_3d661c98f5d0', 'f_0009', "合作主播") }}</h2>
              <div class="en-title">{{ $cms('c_3d661c98f5d0', 'f_0010', "Collaborative Influencer") }}</div>
              <div class="content-desc">{{ $cms('c_3d661c98f5d0', 'f_0011', "行业领先的直播电商基地，提供从选品、直播到售后的全链路专场解决方案") }}</div>
            </div>
            <div class="content-body-2">
              <div class="item" v-for="item in collaborativeInternetCelebritiesList" :key="item.title">
                <div class="mobile">
                  <mobile-video-box :src="item.src" :materialType="item.materialType"></mobile-video-box>
                </div>
                <div class="info">
                  <div class="title" v-html="$cmsHtml(item.title)"></div>
                  <div class="data-box">
                    <div
                      v-for="(data, i) in item.data"
                      :key="i"
                      class="data-item"
                    >
                      <div class="num-line">
                        <div v-if="data.text" class="text">{{ data.text }}</div>
                        <count-to
                          :ref="`count${i}`"
                          :key="i"
                          class="num"
                          separator=""
                          :startVal="0"
                          :endVal="data.num"
                          :duration="1200"
                        ></count-to>
                        <div v-if="data.unit" class="unit">{{ data.unit }}</div>
                        <div v-if="data.plus" class="plus">+</div>
                      </div>
                      <div class="text-line">{{ data.desc }}</div>
                    </div>
                  </div>
                  <div class="desc" v-html="$cmsHtml(item.desc)"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="collaborative-brand-wrapper">
            <div class="content-header">
              <h2 class="title">{{ $cms('c_3d661c98f5d0', 'f_0012', "合作品牌") }}</h2>
              <div class="en-title">{{ $cms('c_3d661c98f5d0', 'f_0013', "Collaborative Brand") }}</div>
              <div class="content-desc">{{ $cms('c_3d661c98f5d0', 'f_0014', "布局20+核心产业带，10万SKU精选货源，助力商家轻松触达精准客群，实现高效变现") }}</div>
            </div>
            <div class="goods-list">
              <div
                v-for="(item, index) in goodsSwiperData"
                :key="index"
                class="good-item"
              >
                <img :src="item.img" loading="lazy" alt="" />
              </div>
            </div>
          </div>
          <div class="specialized-operations-wrapper">
            <div class="content-header">
              <h2 class="title">{{ $cms('c_3d661c98f5d0', 'f_0015', "专场运营") }}</h2>
              <div class="en-title">{{ $cms('c_3d661c98f5d0', 'f_0016', "Specialized Operations") }}</div>
              <div class="content-desc">{{ $cms('c_3d661c98f5d0', 'f_0017', "创新打造\"品牌增长飞轮\"模式，通过主题营销专场，构建品牌-主播-平台三方协同的销售链路") }}</div>
            </div>

            <div class="content-body-2">
              <div class="item" v-for="item in specializedOperationsList" :key="item.title">
                <div class="mobile">
                  <mobile-video-box :src="item.src" :materialType="item.materialType"></mobile-video-box>
                </div>
                <div class="info">
                  <div class="title" v-html="$cmsHtml(item.title)"></div>
                  <div class="data-box" v-if="item.data">
                    <div
                      v-for="(data, i) in item.data"
                      :key="i"
                      class="data-item"
                    >
                      <div class="num-line">
                        <div v-if="data.text" class="text">{{ data.text }}</div>
                        <count-to
                          :ref="`count${i}`"
                          :key="i"
                          class="num"
                          separator=""
                          :startVal="0"
                          :endVal="data.num"
                          :duration="1200"
                        ></count-to>
                        <div v-if="data.unit" class="unit">{{ data.unit }}</div>
                        <div v-if="data.plus" class="plus">+</div>
                      </div>
                      <div class="text-line">{{ data.desc }}</div>
                    </div>
                  </div>
                  <div class="desc" v-html="$cmsHtml(item.desc)"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="cooperation-operations-wrapper">
            <div class="content-header">
              <h2 class="title">{{ $cms('c_3d661c98f5d0', 'f_0018', "立即合作") }}</h2>
              <div class="en-title">{{ $cms('c_3d661c98f5d0', 'f_0019', "Join Mockuai Media") }}</div>
              <div class="content-desc">{{ $cms('c_3d661c98f5d0', 'f_0020', "期待与优秀主播和品牌伙伴合作共赢") }}</div>
            </div>
            <div class="content-body">
              <div class="company-contact-info">
                <div class="item" v-for="item in companyContactInfo" :key="item.title">
                  <div class="icon-box">
                    <img class="icon" :src="item.icon" alt="">
                  </div>
                  <div class="info">
                    <div class="title">{{ item.title }}</div>
                    <div class="desc">{{ item.desc }}</div>
                  </div>
                </div>
              </div>
              <div class="cooperation-info">
                <div class="title">{{ $cms('c_3d661c98f5d0', 'f_0021', "合作流程") }}</div>
                <div class="desc">{{ $cms('c_3d661c98f5d0', 'f_0022', "点击下方，填写合作需求，我们将在3个工作日内联系您") }}</div>
                <div class="btns">
                  <div class="btn-common primary-btn" @click="onJoinClick(1)">{{ $cms('c_3d661c98f5d0', 'f_0023', "主播合作") }}</div>
                  <div class="btn-common base-btn" @click="onJoinClick(2)">{{ $cms('c_3d661c98f5d0', 'f_0024', "商家合作") }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ToolsBar from '@/components/ToolsBar.vue'
import MobileVideoBox from '@/components/MobileVideoBox.vue';
import CountTo from "vue-count-to";

export default {
  components: {
    ToolsBar,
    MobileVideoBox,
    CountTo,
  },
  head() { return this.$cmsHead('c_3d661c98f5d0', {
    title: '主播合作-专业主播孵化与内容创作支持|直播带货|魔筷科技',
    meta: [
      {
        name: 'Keywords',
        content:
          '主播合作,主播孵化,直播带货,内容创作,KOC种草,短视频,大健康,记录生活,主播培训,直播电商,快手,抖音,视频号,小红书,魔筷科技',
      },
      {
        name: 'Description',
        content:
          '魔筷科技专业主播孵化平台，提供内容创作支持服务。记录生活赛道专业机构，独创"全生命周期成长体系"，实现从头部到中尾部主播的梯度培育，为主播提供全方位的成长支持。',
      },
    ],
  }); },
  data() {
    return {
      videoModalVisible: false,
      videoSrc: "",
      coreBusinessList: this.$cms('c_3d661c98f5d0', 'f_0025', [{"icon":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250813113754370000650.17550562741976126.png","title":"全链路达人孵化","list":["• 深度账号诊断×定制人设定位×爆款内容工厂×数据化流量运营×直播带教陪跑","• 深度陪跑0到百万粉，品牌供应链深度赋能，专场场均GMV提升300%+"]},{"icon":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250813113754370000745.17550562741914475.png","title":"内容生态打造","list":["• 团队定制爆款脚本｜抖音/快手/视频号三端S级脚本库｜AI流量预判模型","• 从定位到爆款，我们全程护航，保障你的内容竞争力始终在线！"]},{"icon":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250813113754370000421.17550562741981960.png","title":"强大供应链支撑","list":["• 覆盖美妆个护/家居/大健康食品等热门品类｜佣金领先｜自有品牌供应链专供好品","• 1V1匹配爆品策略｜实时追踪热榜｜滞销无忧退，让您的货盘永远快人一步！"]}]),
      specializedOperationsList: this.$cms('c_3d661c98f5d0', 'f_0026', [{"title":"魔筷年货节盛典<br />三亚巅峰之战圆满收官！","src":"https://mktv-in-cdn.mockuai.com/16255537177625071.mp4","data":[{"num":10,"unit":"亿","desc":"活动总GMV"},{"num":10000,"plus":true,"desc":"活动SKU"},{"num":800,"unit":"%","plus":true,"desc":"参与主播GMV同期增长"}],"desc":"🔥  全域流量生态强势联动：100+头部主播矩阵集结，15天50场垂类专场直播高能轰炸<br />📈   数据见证实力 ：单场平均涨粉超行业200%，全域GMV突破10亿大关，勇夺平台年货节TOP3！ <br />这一战，我们重新定义年货节效率！"},{"title":"魔筷溯源直播<br />探寻源头好物的力量","src":"https://mktv-in-cdn.mockuai.com/16255536991846999.mp4","data":[{"num":30,"unit":"万","plus":true,"desc":"日均成交单数"},{"num":10000,"plus":true,"desc":"参与主播数"},{"num":1000,"plus":true,"desc":"参与工厂数"}],"desc":"🌍 足迹遍布全国：深入1000+优质工厂与核心原产地，从田间枝头到匠心车间，见证每一份品质的诞生。<br />🍜 探访地道风物：走进螺蛳粉、苹果、芒果、海鲜等品类源头，主播化身文化体验官，讲述匠心故事与地方风情。<br />从源头到直播间，让好物自己说话"},{"title":"魔筷「国货复兴」计划<br />杭州现象级盛典战报","src":"https://mktv-in-cdn.mockuai.com/16255537177859354.mp4","data":[{"num":2,"unit":"亿","plus":true,"desc":"活动总GMV"},{"num":10000,"plus":true,"desc":"活动SKU"},{"num":3,"unit":"亿","plus":true,"desc":"活动总曝光"}],"desc":"🔥 顶格资源调度：联动珀莱雅/欧诗漫等1000+国潮尖货，打造年度最强国货直播矩阵<br />🚀 域流量爆破：100+头部KOL×1000+新锐主播饱和渗透，60+场高能直播（含2场千万级流量王炸专场）<br />💰 GMV4亿登顶：问鼎快手国货主题直播历史TOP1，重塑国货消费新势能！<br />✨ 这一战，重新定义跨境直播新标准！"},{"title":"婉婉 × 谷雨<br />美妆专场巅峰战报","materialType":"img","src":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250826154848730000796.17561945284726755.jpg","desc":"🔥 王者战绩：单场GMV突破170万+，强势登顶美妆黑马榜TOP1！<br />💄 爆款神话：百万级超级单品诞生（单链GMV100+），刷新主播历史峰值！<br /><br />📊 运营密码<br />✅ 精准选品策略：锁定\"抗初老\"需求，主推谷雨明星单品山参霜，搭配潜力款组合<br />✅ 流量运营组合拳：短视频预热精准触达万30w+用户，实时监控数据动态调整节奏<br />✅ 高转化玩法设计：阶梯满赠提升客单价40%，限量配方师手写信降低退货率<br />✅ 精细化用户运营：针对未支付用户20分钟内专属客服跟进，挽回15%订单"},{"title":"婷婷不饿 × 跨境保税专场<br />破峰战报 ","materialType":"img","src":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250826154848730000302.17561945284782804.jpg","desc":"🔥 巅峰战绩：专场GMV突破100W+，百万级单品单链销售额100W+，登顶快手营养保健榜TOP1！<br /><br />🌐 赛道突破：成功开拓跨境新品类，刷新主播历史单品峰值纪录！<br /><br />✨ 这一战，重新定义跨境直播新标准！"},{"title":"罗姐姐 × 御泥坊<br />美妆溯源专场巅峰战报","materialType":"img","src":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250826154848730000357.17561945284787709.jpg","desc":"🔥 破峰战绩：单场GMV突破155万+，实现历史300%增长飞跃，登顶快手美妆个护TOP1！<br /><br />💎 高客单价奇迹：在货盘均价+基础上，驱动客单价飙升至220+，人均价值翻倍突破！<br /><br />✨ 这一战，重新定义美妆品牌溯源直播新标准！"}]),
      collaborativeInternetCelebritiesList: this.$cms('c_3d661c98f5d0', 'f_0027', [{"title":"小沈龙","src":"https://mktv-in-cdn.mockuai.com/16255537177882831.mp4","data":[{"num":3300,"unit":"万","desc":"5小时GMV"},{"num":30,"unit":"万","plus":true,"desc":"在线人数"}],"desc":"2020年魔筷5周年庆期间，魔筷与小沈龙共同组织策划直播专场活动。为此，魔筷特邀女神“周韦彤”到现场，为小沈龙引流。同时，魔筷精心策划直播间脚本，并仔细进行选品组货，确保直播节奏和维护在线流量。活动结束后，小沈龙对魔筷的贴心服务表示十分认可。"},{"title":"浪胃仙直播专场","src":"https://mktv-in-cdn.mockuai.com/16255537177918545.mp4","data":[{"text":"第","num":1,"unit":"名","desc":"快手热搜榜"},{"num":100,"unit":"万","plus":true,"desc":"在线人数"}],"desc":"2019年底，魔筷举办浪胃仙直播专场活动，并邀请著名笑星杨迪共同参与。直播开始后，直播间人气迅速攀升，不到5分钟就占据快手热搜榜第一名。这些都依托于魔筷的前期预热能力以及直播间的运营能力。据浪胃仙的运营人员反应，本场活动是浪胃仙在快手上人气最高的专场之一。"},{"title":"婉婉吖","src":"https://mktv-in-cdn.mockuai.com/16267467999957193.mp4","data":[{"num":167,"unit":"万","desc":"粉丝量"},{"num":600,"unit":"万","desc":"月均成交能力"},{"num":5,"unit":"年","desc":"入驻时长"}],"desc":"婉婉吖依托魔筷传媒专业团队，构建了‘货品力+内容力+直播力’三位一体驱动模型。通过精准选品、差异化内容与高能转化，成功孵化多款现象级爆品，高效拓展美妆、大健康、食品、服饰四大核心品类直播专场。<br />美妆领跑者：登顶类目黑马榜TOP 1，单场GMV峰值200万+！<br />强劲增长典范：荣膺2024平台TOP权威增长主播！"},{"title":"婷婷不饿","src":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250815104950670000582.17552261904702899.jpg?x-oss-process=image/quality,Q_80","materialType":"img","data":[{"num":50,"unit":"万","desc":"粉丝量"},{"num":300,"unit":"万","desc":"月均成交能力"}],"desc":"魔筷传媒助力主播婷婷不饿，打造“货品力×内容力×直播力”三维增长矩阵，成功孵化多款现象级爆品。<br />精准布局美妆及大健康赛道，实现单品单链百万级爆破；历史战绩登顶单日美妆榜&营养保健榜TOP1。<br />魔筷科技专注强运营驱动高效转化与品类破圈，成就全域增长头部主播。"},{"title":"滕滕包包","src":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250815104950670000733.17552261904724623.jpg?x-oss-process=image/quality,Q_80","materialType":"img","data":[{"num":150,"unit":"万","desc":"粉丝量"},{"num":300,"unit":"万","desc":"月均成交能力"}],"desc":"魔筷传媒以精细化运营策略与专业内容策划，成功助力主播构建多账号协同矩阵：孵化5个强效带货子账号，月均贡献GMV 20万+，实现全域流量布局与销售增量挖掘。<br />打造“主播粉丝节”等大型营销IP活动，强势引爆主账号流量，单场活动成功吸粉100万+，并实现单场GMV 200万+的里程碑式跃迁，峰值带货效能实现惊人2000%增长"},{"title":"罗姐姐","src":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250815104950670000261.17552261904671106.jpg?x-oss-process=image/quality,Q_80","materialType":"img","data":[{"num":47,"unit":"万","desc":"粉丝量"},{"num":300,"unit":"万","desc":"月均成交能力"}],"desc":"魔筷传媒深度赋能主播：<br />半年内赋能逻主播罗姐姐实现单月GMV翻倍，并连续5个月精准复制百万级专场模型，单月峰值破300万，验证其高产出能力与成熟爆款模型。<br />深度定制挖掘其独特民族身份与文化属性，打造“弟弟结婚”个性化货送营销，专业操盘引爆单场GMV 170万+，实时在线破万，创造个人效能巅峰"}]),
      goodsSwiperData: this.$cms('c_3d661c98f5d0', 'f_0028', [{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833020000141.17564603115643762.png"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833020000472.17564603115692316.png"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833020000271.17564603115724205.png"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833020000867.17564603115773974.png"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833020000762.17564603115791077.png"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833020000380.17564603115865676.png"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833020000645.17564603115887789.png"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833020000523.17564603115909510.png"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833020000511.17564603115933107.png"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833020000193.17564603115941352.png"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833020000960.17564603115953290.png"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833020000223.17564603115965488.png"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833020000840.17564603115616842.png"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833020000399.17564603115978984.png"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833030000515.17564603115998771.png"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833030000421.17564603116086843.png"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833040000199.17564603116126020.png"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833030000106.17564603116137920.png"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833020000316.17564603115976169.png"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833030000136.17564603115987520.png"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250829173833030000873.17564603116041088.png"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250910152502840000141.17574891012527982.png"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250911164601140000802.17575803609761578.png"},{"img":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250804175609470000937.17543013691806411.png"}]),
      companyContactInfo: this.$cms('c_3d661c98f5d0', 'f_0029', [{"icon":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250813151554160000777.17550693539606765.png","title":"杭州总部","desc":"杭州市余杭区仓前街道龙泉路20号魔筷科技园"},{"icon":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250813151554160000991.17550693539631669.png","title":"联系我们","desc":"400-900-1231 丨 hz@mockuai.com"},{"icon":"https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250813151554160000811.17550693539648784.png","title":"工作时间","desc":"周一至周五 9：00-18：00 （节假日除外）"}]),
    }
  },
  methods: {
    onJoinClick(type) {
      this.$router.push(`/apply-join?type=${type}`)
    },
  },
}
</script>

<style lang="less" scoped>
@import "../style/common.less";

.media-content {
  padding-top: 90px;
}

.service-wrapper {
  .banner-wrapper {
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    .pxToVw(height, 680);
    background-image: var(--cms-c_3d661c98f5d0-f_0030, url("https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250805191951120000640.17543927909929175.jpg?x-oss-process=image/quality,Q_80"));
    background-size: cover;
    background-repeat: no-repeat;
    h1.title {
      .pxToVw(margin-bottom, 13);
      line-height: 1.4;
      .pxToVw(font-size, 60);
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #fff;
    }
    .desc {
      .pxToVw(line-height, 33);
      .pxToVw(font-size, 24);
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fff;
    }
    .actions {
      display: flex;
      align-items: center;
      .pxToVw(margin-top, 77);
      .btn {
        box-sizing: border-box;
        .pxToVw(width, 220);
        .pxToVw(height, 60);
        .pxToVw(line-height, 60);
        text-align: center;
        .pxToVw(margin-right, 40);
        border: 1px solid #fff;
        .pxToVw(border-radius, 30);
        .pxToVw(font-size, 24);
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #fff;
        cursor: pointer;
        &:last-child {
          margin-right: 0;
        }
        &:hover {
          border: none;
          background-color: #fff;
          color: #333;
        }
        &.btn-white {
          background-color: #fff;
          color: #ff6600;
          &:hover {
            background-color: #ff6600;
            color: #fff;
          }
        }
      }
    }
  }
  .content-wrapper {
    .content-header {
      .pxToVw(padding-top, 92);
      color: #333333;
      h2.title {
        margin: 0 auto 8 * @unitVw;
        .pxToVw(margin-bottom, 28);
        text-align: center;
        .pxToVw(line-height, 50);
        .pxToVw(font-size, 36);
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        position: relative;
        &::after {
          content: "";
          position: absolute;
          .pxToVw(top, 64);
          left: 50%;
          .pxToVw(width, 160);
          height: 1px;
          background: #d8d8d8;
          transform: translateX(-50%);
        }
        
      }
      .en-title {
        font-weight: 500;
        .pxToVw(font-size, 18);
        .pxToVw(line-height, 26);
        text-align: center;
        .pxToVw(margin-bottom, 26);
      }
      .content-desc {
        text-align: center;
        .pxToVw(line-height, 25);
        .pxToVw(font-size, 18);
        font-weight: 300;
        color: #666;
      }
    }
    .collaborative-brand-wrapper {
      background: #00092A;
      .content-header {
        color: #fff;
        .content-desc {
          color: #fff;
        }
      }
     
      .goods-list {
        .pxToVw(padding-top, 60);
        .pxToVw(padding-bottom, 80);
        // width: 53%;
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        gap: 50px;
        .good-item {
          width: 100px;
          height: 100px;
        }
        img {
          display: block;
          width: 100%;
        }
      }
      // @media screen and (min-width: 1440px) {
      //   .goods-list {
      //     width: 50%;
      //   }
      // }
    }
    .cooperation-operations-wrapper {
      background: #00092A;
      background-image: var(--cms-c_3d661c98f5d0-f_0031, url("https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250813151027010000754.17550690267161168.png"));
      background-size: cover;
      background-repeat: no-repeat;
      .pxToVw(height, 708);
      .content-header {
        color: #fff;
        .content-desc {
          color: #fff;
        }
      }
      .content-body {
        display: flex;
        justify-content: space-between;
        .pxToVw(padding-top, 80);
        .pxToVw(width, 1350);
        margin: 0 auto;
        .company-contact-info {
          flex: 1;
          display: flex;
          flex-direction: column;
          .pxToVw(gap, 40);
          .item {
            display: flex;
            .icon-box {
              .pxToVw(width, 46);
            }
            .icon {
              .pxToVw(height, 30);
              .pxToVw(margin-top, 7);
            }
            .info {
              .title {
                font-weight: 600;
                .pxToVw(font-size, 30);
                .pxToVw(line-height, 42);
                color: #FFFFFF;
              }
              .desc {
                .pxToVw(margin-top, 16);
                font-weight: 300;
                .pxToVw(font-size, 18);
                .pxToVw(line-height, 25);
                color: #FFFFFF;
              }
            }
          }
        }
        .cooperation-info {
          box-sizing: border-box;
          background-image: var(--cms-c_3d661c98f5d0-f_0032, url("https://wdzg-file-online-cdn.mockuai.com/picture/open_file20250813150808700000129.17550688881619247.png"));
          background-size: cover;
          background-repeat: no-repeat;
          .pxToVw(width, 800);
          .pxToVw(height, 329);
          .pxToVw(padding-top, 60);
          .pxToVw(padding-left, 160);
          .title {
            font-weight: 600;
            .pxToVw(font-size, 30);
            .pxToVw(line-height, 42);
            color: #333333;
          }
          .desc {
            font-weight: 300;
            .pxToVw(font-size, 18);
            .pxToVw(line-height, 25);
            .pxToVw(margin-top, 16);
            color: #333333;
          }
          .btns {
            .pxToVw(margin-top, 66);
            display: flex;
            .pxToVw(gap, 40);
            .primary-btn {
              background: #FF6600;
              border: 0px solid #fff;
              box-shadow: 0px 7px 21px 0px rgba(255,102,0,0.4);
              &:hover {
                color: #fff;
              }
            }
            .base-btn {
              border: 1px solid #FF6600;
              color: #ff6600;
              &:hover {
                color: #ff6600;
                background-color: inherit;
              }
            }
          }
        }
      }
    }
    .content-body-1 {
      box-sizing: border-box;
      .pxToVw(margin-top, 97);
      .pxToVw(padding-left, 240);
      .pxToVw(padding-right, 240);
      .pxToVw(padding-bottom, 80);
      display: flex;
      .pxToVw(gap, 60);
      .item {
        position: relative;
        flex: 1;
        .pxToVw(border-radius, 20);
        .pxToVw(height, 300);
        .pxToVw(padding-right, 30);
        .pxToVw(padding-left, 30);
        .pxToVw(padding-top, 100);
        background: #FFFFFF;
        .icon {
          position: absolute;
          .pxToVw(top, -37);
          .pxToVw(right, 46);
        }
        .item-title {
          .pxToVw(font-size, 30);
          font-weight: 600;
          color: #333333;
          .pxToVw(line-height, 36);
        }
        li {
          .pxToVw(font-size, 18);
          .pxToVw(padding-top, 38);
          font-weight: 300;
          color: #666;
          .pxToVw(line-height, 30);
        }
        &:nth-child(1) {
          .icon {
            .pxToVw(width, 90);
          }
        }
        &:nth-child(2) {
          .icon {
            .pxToVw(width, 103);
            .pxToVw(right, 39);
          }
        }
        &:nth-child(3) {
          .icon {
            .pxToVw(width, 98);
          }
        }
      }
    }

    .content-body-2 {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      .item {
        width: 40%;
        display: flex;
        align-items: center;
        .info {
          flex: 1;
          .pxToVw(margin-left, -30);
          .title {
            font-weight: 600;
            .pxToVw(margin-bottom, 30);
            .pxToVw(font-size, 30);
            color: #333333;
            .pxToVw(line-height, 42);
            text-align: left;
            font-style: normal;
          }
          .data-box {
            display: flex;
            align-items: flex-start;
            .data-item {
              display: flex;
              flex-direction: column;
              align-items: center;
             
              &:nth-child(1) {
                .pxToVw(margin-right, 40);
                .pxToVw(width, 100);
              }
              &:nth-child(2) {
                .pxToVw(margin-right, 40);
              }
              .num-line {
                display: flex;
                align-items: flex-end;
                .text {
                  .pxToVw(margin-bottom, 10);
                }
                .num {
                  .pxToVw(line-height, 68);
                  .pxToVw(font-size, 60);
                  font-family: DINCond-Light, DINCond;
                  font-weight: 300;
                  color: #333;
                }
                .text,
                .unit,
                .plus {
                  line-height: 1.4;
                  .pxToVw(font-size, 20);
                  font-family: PingFangSC-Thin, PingFang SC;
                  font-weight: 100;
                  color: #333;
                }
                .unit {
                  .pxToVw(margin-bottom, 10);
                }
                .plus {
                  align-self: center;
                }
              }
              .text-line {
                .pxToVw(line-height, 25);
                .pxToVw(font-size, 18);
                font-family: PingFangSC-Light, PingFang SC;
                font-weight: 300;
                color: #666;
                text-align: center;
              }
            }
            
          }
          .desc {
            font-weight: 300;
            .pxToVw(font-size, 18);
            color: #666666;
            .pxToVw(line-height, 25);
            text-align: left;
            font-style: normal;
            .pxToVw(margin-top, 40);
          }
        }
      }
    }
  }
}
</style>
